import { useMemo } from 'react';

import { TypeDecoratedSubEngineSubscription } from '@/lib/api/subscriptionManager/decorators/subEngine/decorateSubEngineSubscriptions';

const useDefaultSelectedSubscriptionId = (
  subscriptions: TypeDecoratedSubEngineSubscription[],
) =>
  useMemo(() => {
    const defaultSelectedSubscription = subscriptions?.find(
      (subscription) => subscription.isDefaultSelectedSubscription,
    );

    return defaultSelectedSubscription?.id || subscriptions?.[0]?.id;
  }, [subscriptions]);

export default useDefaultSelectedSubscriptionId;
